<template>
	<div id="header" class="fixed-top bg-white">
		
		<!-- Slim Header - stile AGID -->
		<div class="it-header-slim-wrapper" :class="{ 'scrolled':false}">
			<div class="container-xxl">
				<div class="row">
					<div class="col-12">
						<div class="it-header-slim-wrapper-content">
							<div class="d-flex align-items-center">
								<a class="navbar-brand p-0" target="_blank" href="https://www.governo.it/it">Governo Italiano<svg class="icon" aria-hidden="true"><use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-external-link"'></use></svg></a>
							</div>
							<div class="header-slim-right d-flex align-items-center">
								<a class="navbar-brand p-0 me-3" target="_blank" href="https://www.serviziocontrattipubblici.it/it/piattaforme-e-strumenti/scp-supporto-giuridico">SCP Supporto Giuridico<svg class="icon" aria-hidden="true"><use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#it-external-link"'></use></svg></a>
								<DocumentComposition class="me-2"/>
								<UserSection class="me-2"/>
								<a class="btn" target="_blank" href="https://www.serviziocontrattipubblici.org/Home/contatti">Contatti</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="shadow d-none d-lg-block" style="background-color: #00468b;">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-12">
						<div class="it-header-center-content-wrapper mt-3">
							<BreadcrumbNode :article="this.$root.breadcrumbData.article" :section="this.$root.breadcrumbData.section"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.mobile-menu {
	display: flex;
	height: calc(100vh);
	flex-direction: column !important;
}

.mobile-menu>a {
	margin-top: 1.4em;
	margin-left: 2em;
	flex-grow: 0;
	transition: opacity 0.3s ease-in-out 0s, color 0.3s ease-in-out 0s, background-color 0.3s ease-in-out 0s, text-decoration 0.3s ease-in-out 0s, top 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s, bottom 0.3s ease-in-out 0s, left 0.3s ease-in-out 0s, width 0.3s ease-in-out 0s, max-width 0.3s ease-in-out 0s, height 0.3s ease-in-out 0s, max-height 0.3s ease-in-out 0s, padding-top 0.3s ease-in-out 0s, padding-right 0.3s ease-in-out 0s, padding-bottom 0.3s ease-in-out 0s, padding-left 0.3s ease-in-out 0s, box-shadow 0.3s ease-in-out 0s, border-color 0.3s ease-in-out 0s, transform 0.3s ease-in-out 0s;
}

.mobile-menu>a:hover {
	border-left: 2px solid #003366;
	background-color: transparent;
	color: #0066cc;
	margin-left: calc(2em - 2px);
}

.menu-link {
	color: #0066cc;
	font-weight: bold;
	text-decoration: none;
	transition: opacity 0.3s ease-in-out 0s, color 0.3s ease-in-out 0s, background-color 0.3s ease-in-out 0s, text-decoration 0.3s ease-in-out 0s, top 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s, bottom 0.3s ease-in-out 0s, left 0.3s ease-in-out 0s, width 0.3s ease-in-out 0s, max-width 0.3s ease-in-out 0s, height 0.3s ease-in-out 0s, max-height 0.3s ease-in-out 0s, padding-top 0.3s ease-in-out 0s, padding-right 0.3s ease-in-out 0s, padding-bottom 0.3s ease-in-out 0s, padding-left 0.3s ease-in-out 0s, box-shadow 0.3s ease-in-out 0s, border-color 0.3s ease-in-out 0s, transform 0.3s ease-in-out 0s
}

.menu-link:hover {
	text-decoration: underline;
	background-color: #0066cc;
	color: #FFF;
}

.title {
	font-weight: 700;
	font-style: 'normal';
	color: #0066cc;
}

h1.title {
	font-size: 37px;
}

.it-header-slim-wrapper {
	background-color: #003366
}

.it-header-slim-wrapper-content>a {
	font-size: 16px;
}

.contact-link {
	position:relative;
	top:-3px
}
</style>

<script>

import UserSection from "@/components/partials/UserSection.vue";
import BreadcrumbNode from "@/components/navigator/BreadcrumbNode.vue"
import DocumentComposition from "@/components/partials/DocumentComposition.vue"

export default {
	name: "HeaderTemplate",
	components: {
		UserSection,
		BreadcrumbNode,
		DocumentComposition
	},
	data: () => {
		return {
			openMenu: false
		}
	},
	props: {},
	methods: {
		checkWidth() {
			if (document.documentElement.clientWidth > 767) {
				this.openMenu = false;
			}
		}
	},
	mounted() {
		this.checkWidth();
		window.addEventListener("resize", this.checkWidth);
		
		// Watch for changes in the root component's breadcrumbData
		this.$watch(
			() => this.$root.breadcrumbData,
			() => {
				// Force component update when breadcrumbData changes
				this.$forceUpdate();
			},
			{ deep: true }
		);
	},
	unmounted() {
		window.removeEventListener("resize", this.checkWidth);
	}
}

</script>
